import { render, staticRenderFns } from "./ProjectBuildingImporterFeedback.vue?vue&type=template&id=004c0cbe&scoped=true&"
import script from "./ProjectBuildingImporterFeedback.vue?vue&type=script&lang=ts&"
export * from "./ProjectBuildingImporterFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectBuildingImporterFeedback.vue?vue&type=style&index=0&id=004c0cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c0cbe",
  null
  
)

export default component.exports